import {
  generateKey,
  DomainAPI,
  Channel,
  APIKey,
  Authorization,
  VNPayConfig,
  sortObject,
} from "../utils/setting";
import { checkResponse } from "../utils/checkResponse";
import moment from "moment";
import { stringify } from "query-string";
import sha256 from "sha256";
const serviceAccount = {
  state: {
    serviceAccount: {},
    serviceCode: "",
  },
  reducers: {
    setState(state, payload) {
      state = { ...state, ...payload };
      return { ...state };
    },
    changeServiceCode(state, payload) {
      state.serviceCode = payload.serviceCode;
      return { ...state };
    },
  },
  effects: (dispatch = {}) => ({
    getServiceAccount(payload = {}, rootState) {
      const _this = this;
      let url =
        DomainAPI + Channel + "/api/secure/serviceAccounts/getServiceAccount";

      return fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          [APIKey]: generateKey(),
          [Authorization]: rootState.user.token,
        },
        body: JSON.stringify({
          serviceCode: rootState.service.adminService.no,
          ...payload,
        }),
      })
        .then((res) => res.json())
        .then((result) => {
          checkResponse(result, dispatch);
          if (result.code === 1)
            _this.setState({ serviceAccount: result.data || {} });
          return result;
        })
        .catch((error) => {
          return { code: 0, error: error, message: error.message };
        });
    },
    updateServiceAccount(payload = {}, rootState) {
      let url =
        DomainAPI +
        Channel +
        "/api/secure/serviceAccounts/updateServiceAccount";

      return fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          [APIKey]: generateKey(),
          [Authorization]: rootState.user.token,
        },
        body: JSON.stringify({
          serviceCode: rootState.service.adminService.no,
          ...payload,
        }),
      })
        .then((res) => res.json())
        .then((result) => {
          return result;
        })
        .catch((error) => {
          return { code: 0, error: error, message: error.message };
        });
    },
    addPayment(payload = {}, rootState) {
      let url = DomainAPI + Channel + "/api/secure/serviceAccounts/addPayment";
      return fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          [APIKey]: generateKey(),
          [Authorization]: rootState.user.token,
        },
        body: JSON.stringify({
          serviceCode: rootState.service.adminService.no,
          ...payload,
        }),
      })
        .then((res) => res.json())
        .then((result) => {
          return result;
        })
        .catch((error) => {
          return { code: 0, error: error, message: error.message };
        });
    },
    addBalanceForOwner(payload = {}, rootState) {
      let url =
        DomainAPI + Channel + "/api/secure/serviceAccounts/addBalanceForOwner";
      return fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          [APIKey]: generateKey(),
          [Authorization]: rootState.user.token,
        },
        body: JSON.stringify(payload),
      })
        .then((res) => res.json())
        .then((result) => {
          return result;
        })
        .catch((error) => {
          return { code: 0, error: error, message: error.message };
        });
    },
    checkoutPayment(payload, rootState) {
      return fetch(DomainAPI + Channel + "/api/secure/stripe/checkoutPayment", {
        method: "POST",
        body: JSON.stringify(payload),
        headers: {
          "Content-Type": "application/json",
          [APIKey]: generateKey(),
          [Authorization]: rootState.user.token,
        },
      })
        .then((res) => res.json())
        .then(function (result) {
          return result;
        })
        .catch((err) => {
          console.log(err);
          return {
            code: false,
            message: err.message,
            error: err,
          };
        });
    },
    createPaymentVNPay(payload = {}, rootState) {
      let vnPayParams = {};
      var date = new Date().getTime();
      vnPayParams["vnp_Version"] = "2.0.0";
      vnPayParams["vnp_Command"] = "pay";
      vnPayParams["vnp_TmnCode"] = VNPayConfig.vnp_TmnCode;
      vnPayParams["vnp_Merchant"] = "DEMO";
      vnPayParams["vnp_Locale"] = payload.locale;
      vnPayParams["vnp_CurrCode"] = payload.currency;
      vnPayParams["vnp_TxnRef"] = Math.round(date)
        .toString(16)
        .toLocaleUpperCase(); // orderId
      vnPayParams["vnp_OrderInfo"] = payload.info;
      vnPayParams["vnp_OrderType"] = VNPayConfig.vnp_orderType;
      vnPayParams["vnp_Amount"] = Number(payload.amount) * 100;
      vnPayParams["vnp_ReturnUrl"] = payload.returnUrl;
      vnPayParams["vnp_IpAddr"] = rootState.setting.ipAddress;
      // vnPayParams['vnp_IpAddr'] = '203.205.32.96';
      vnPayParams["vnp_CreateDate"] = moment(date).format("YYYYMMDDHHmmss");
      // vnPayParams['vnp_BankCode'] = '';
      vnPayParams["vnp_BankCode"] = payload.bankCode;
      vnPayParams = sortObject(vnPayParams);
      let signData =
        VNPayConfig.vnp_HashSecret + stringify(vnPayParams, { encode: false });
      var secureHash = sha256(signData);
      vnPayParams["vnp_SecureHashType"] = "SHA256";
      vnPayParams["vnp_SecureHash"] = secureHash;
      let url = `${VNPayConfig.vnp_Url}?${stringify(vnPayParams)}`;
      window.open(url, "_self");
    },
    createPaymentZaloPay(payload = {}, rootState) {
      let url = DomainAPI + Channel + "/api/secure/zalopay/createOrder";
      return fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          [APIKey]: generateKey(),
          [Authorization]: rootState.user.token,
        },
        body: JSON.stringify(payload),
      })
        .then((res) => res.json())
        .then((result) => {
          if (result.code === 1) {
            // console.log("Result: ", result);
            window.open(result.data.order_url, "_self");
          }
          return result;
        })
        .catch((error) => {
          return { code: 0, error: error, message: error.message };
        });
    },
    getStatusByApptransid(payload = {}, rootState) {
      let url = `${DomainAPI}${Channel}/api/secure/zalopay/getStatusByApptransid?${stringify(
        payload
      )}`;
      return fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          [APIKey]: generateKey(),
          [Authorization]: rootState.user.token,
        },
      })
        .then((res) => res.json())
        .then((result) => {
          return result;
        })
        .catch((error) => {
          console.log("error: ", error);
          return { code: 0, error: error, message: error.message };
        });
    },
  }),
};

export default serviceAccount;
